import React from 'react'

import { Box, Text, useClassNames } from '@factorialco/deprecated-design-system'
import { type ComplaintsDataCollectionItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import {
  ActivityElement,
  type ActivityItem,
} from 'modules/complaints/pages/ComplaintDetailPage/ComplaintActivity/Feed/ActivityElement'
import * as styles from 'modules/complaints/pages/ComplaintDetailPage/ComplaintActivity/Feed/index.vanilla.css'

interface ActivityFeedProps {
  complaint: ComplaintsDataCollectionItemFragment
}

const ActivityFeed: React.FC<ActivityFeedProps> = ({ complaint }) => {
  const cx = useClassNames(styles)
  if (!complaint) {
    return (
      <Box paddingY="s32" paddingX="s48" justifyContent="center" alignItems="center" width="full">
        <Text.Normal color="grey800">{i18n.t('common.error')}</Text.Normal>
      </Box>
    )
  }

  const statusActivities: ActivityItem[] = []

  const statusConfigs = [
    {
      field: 'createdAt' as const,
      id: 'status-created',
      title: i18n.t('complaints.activity.feed.created_at'),
    },
    {
      field: 'acknowledgedAt' as const,
      id: 'status-acknowledged',
      title: i18n.t('complaints.activity.feed.acknowledged_at'),
    },
    {
      field: 'completedAt' as const,
      id: 'status-completed',
      title: i18n.t('complaints.activity.feed.completed_at'),
    },
    {
      field: 'discardedAt' as const,
      id: 'status-discarded',
      title: i18n.t('complaints.activity.feed.discarded_at'),
    },
    {
      field: 'archivedAt' as const,
      id: 'status-archived',
      title: i18n.t('complaints.activity.feed.archived_at'),
    },
  ]

  statusConfigs.forEach(({ field, id, title }) => {
    const date = complaint[field]
    if (date) {
      statusActivities.push({
        id,
        title,
        date,
        isStatusChange: true,
        type: 'status_change',
      })
    }
  })

  const activities = [...statusActivities].sort((a, b) => {
    return new Date(b.date).getTime() - new Date(a.date).getTime()
  })

  return (
    <Box className={cx('feed')}>
      <Box gap="s12" paddingRight="s32" position="relative">
        <Box className={cx('bar')} />
        {activities.map((activity, index) => (
          <ActivityElement
            key={activity.id + '_status_activity'}
            activity={activity}
            isLast={index === activities.length - 1}
            isFirst={index === 0}
          />
        ))}
      </Box>
    </Box>
  )
}

export default ActivityFeed
